import { Pipe, PipeTransform } from '@angular/core';
import { SOLAR_COMPONENT_TYPES } from '@apps/api-interfaces';

@Pipe({
  name: 'componentName'
})
export class ComponentNamePipe implements PipeTransform {
  public transform(type: string, field: string = 'label1'): string {
    const item = SOLAR_COMPONENT_TYPES.find(e => e.id === type);
    return (item && item[field]) || 'Komponent';
  }
}
